var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMembers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.327,
    height: 14,
    viewBox: "0 0 16.327 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_19",
    "data-name": "Union 19",
    d: "M10605.594,13.112V11.755a1.82,1.82,0,0,0-1.339-1.769.892.892,0,0,1-.623-1.083.865.865,0,0,1,1.057-.638,3.588,3.588,0,0,1,2.64,3.487v1.359a.867.867,0,1,1-1.734,0Zm-3.98,0V11.755a1.809,1.809,0,0,0-1.784-1.829h-5.308a1.752,1.752,0,0,0-1.263.535,1.838,1.838,0,0,0-.523,1.294v1.357a.867.867,0,1,1-1.734,0V11.755a3.619,3.619,0,0,1,1.032-2.55,3.455,3.455,0,0,1,2.488-1.056h5.308a3.568,3.568,0,0,1,3.52,3.606v1.357a.868.868,0,1,1-1.735,0Zm-7.96-9.507a3.522,3.522,0,1,1,7.042,0,3.522,3.522,0,1,1-7.042,0Zm1.736,0a1.786,1.786,0,1,0,3.571,0,1.786,1.786,0,1,0-3.571,0Zm5.588,2.856a.89.89,0,0,1,.625-1.081,1.839,1.839,0,0,0,0-3.543.89.89,0,0,1-.625-1.081.864.864,0,0,1,1.056-.639,3.585,3.585,0,0,1,2.647,3.491,3.588,3.588,0,0,1-2.647,3.492.856.856,0,0,1-.216.028A.871.871,0,0,1,10600.978,6.46Z",
    transform: "translate(-10591.001)",
    fill: "#b402f6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.b27c1c54c526e4de026c51d660dc6ba1.svg";
export { ForwardRef as ReactComponent };